module.exports = __webpack_public_path__ + "static/media/PRY.f5fd60e7.svg";